/**
 * Service: templatesHelpers
 */
angular.module('acme.common.service.templates.helpers', [
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.service.userPreferences'
])
.service('TemplatesHelpersService', ['$filter', 'CalendarService', 'HelpersService', 'UserPreferencesService', function($filter, CalendarService, HelpersService, UserPreferencesService) {

    return {

      init: function() {
        return true;
      },

      getRepeatType: function(repeatTypes, type) {
        var i, ii,
            r = false;

        if (repeatTypes instanceof Array) {
          for (i = 0, ii = repeatTypes.length; i < ii; i++) {
            if (repeatTypes[i].value === type) {
              r = repeatTypes[i];
              break;
            }
          }
        }

        return r;
      },

      getAdmissionTypes: function() {
        return [
          {
            label: 'Standard',
            name: 'standard'
          },
          {
            label: 'General Admission',
            name: 'generalAdmission'
          }
        ];
      },

      getRepeatTypes: function() {
        return [
          {
            label: 'One-Time',
            value: 'never'
          },
          {
            label: 'Daily',
            value: 'day'
          },
          {
            label: 'Weekly',
            value: 'week'
          },
          {
            label: 'Monthly',
            value: 'month'
          }
        ];
      },

      getRepeatMonthTypes: function() {
        return [
          {
            label: 'on the',
            value: 'date'
          },
          {
            label: 'Every first',
            value: 'first'
          },
          {
            label: 'Every second',
            value: 'second'
          },
          {
            label: 'Every third',
            value: 'third'
          },
          {
            label: 'Every fourth',
            value: 'fourth'
          },
          {
            label: 'Every fifth',
            value: 'fifth'
          }
        ];
      },

      getSalesChannels: function() {
        return [
          {
            name: 'Web',
            channel: 'online',
            enabled: true
          },
          {
            name: "Point of Sale",
            channel: "pointOfSale",
            enabled: true
          },
          {
            name: "Reseller",
            channel: "reseller",
            enabled: true
          },
          {
            name: "Customer Rep",
            channel: "customerRep",
            enabled: true
          },
          {
            name: "Manual Entry",
            channel: "manualEntry",
            enabled: true
          },
          {
            name: "Kiosk",
            channel: "kiosk",
            enabled: true
          }
        ];
      },

      getFlexpayType: function(flexpayTypes, type) {
        var i, ii,
          r = false;

        if (flexpayTypes instanceof Array) {
          for (i = 0, ii = flexpayTypes.length; i < ii; i++) {
            if (flexpayTypes[i].value === type) {
              r = flexpayTypes[i];
              break;
            }
          }
        }

        return r;
      },

      getFlexpayTypes: function() {
        return [
          {
            label: 'Pay what you wish',
            value: 'payWhatYouWish'
          },
          {
            label: 'Discount',
            value: 'discount'
          }
        ];
      },

      getEffectiveDates: function(start, end) {
        var r = $filter('date')(CalendarService.parseDate(start), UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));

        if (end) {
          r += ' - ';
          r += $filter('date')(CalendarService.parseDate(end), UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
        }else{
          r += ' - Indefinite';
        }

        return r;
      },

      getTimeFormat: function() {
        return UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
      },

      getResourceRequestTypes: function(resourceRequests) {
        var i, ii,
            entityName,
            types = [];

        if (resourceRequests instanceof Array) {
          for (i=0,ii=resourceRequests.length;i<ii;i++) {
            entityName = HelpersService.cap(HelpersService.getEntityName(resourceRequests[i].eventResource.resourceCategory).displayPlural);
            if (types.indexOf(entityName) === -1) {
              types.push(entityName);
            }
          }
        }

        return (types.length) ? types.join(', ') : 'None';

      },

      /**
       * Returns color category stylesheet for grid rows
       *
       * @param colorCategory { textColor: hex | rgb | rgba, backgroundColor: hex | rgb | rgba }
       * @returns {{display: string, position: string, top: string, left: string, height: string, width: string, color: string, background-color: string}}
       */
      getColorCategoryStyle: function(colorCategory) {
        var textColor = '#FFFFFF',
            backgroundColor = '#000000';

        if (colorCategory.hasOwnProperty('textColor') &&
            typeof(colorCategory.textColor) === 'string' &&
            colorCategory.hasOwnProperty('backgroundColor') &&
            typeof(colorCategory.backgroundColor) === 'string') {
          textColor = colorCategory.textColor;
          backgroundColor = colorCategory.backgroundColor;
        }

        return {
          'display': 'block',
          'position': 'absolute',
          'top': '0',
          'left': '0',
          'height': '100%',
          'width': '4px',
          'color': textColor,
          'background-color': backgroundColor
        };
      },

      createHour: function() {
        return {
          hour: 9,
          minutes: 0,
          quantity: 1
        };
      },

      createRange: function() {
        return {
          start: {
            hour: 9,
            minutes: 0
          },
          end: {
            hour: 17,
            minutes: 0
          }
        };
      },

      hourToDate: function(hour) {

        var d = new Date();

        if (hour) {
          d.setHours(hour.hour);
          d.setMinutes(hour.minutes);
          d.setSeconds(0);
          d.setMilliseconds(0);
        }

        return (d instanceof Date) ? d : new Date();

      },

      findTemplate: function(templates, id) {
        var i, ii,
            r = false;

        for (i=0,ii=templates.length;i<ii;i++) {
          if (templates[i].id === id) {
            r = {
              template: templates[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      findTicketType: function(template, id) {
        var i, ii,
            r = false;

        if (template.priceLists instanceof Array && template.priceLists[0]) {
          if (template.priceLists[0].prices instanceof Array && template.priceLists[0].prices[0]) {
            for (i=0,ii=template.priceLists[0].prices.length;i<ii;i++) {
              if (template.priceLists[0].prices[i].personType.id === id) {
                r = {
                  ticketType: template.priceLists[0].prices[i].personType,
                  index: i
                };
                break;
              }
            }
          }
        }

        return r;
      }

    };

}]);